import React from 'react';
import styled from '@emotion/styled';
import { style } from '@app/shared/lib/Style';
import { FormField } from '../../../../components/Forms/FormField';
import { Modal } from '../../../../components/Modal/Modal';
import { SettingStore } from '../../../settings/SettingsStore';
import { L } from '../../../../lib/i18n';
import { Button } from '@ourliving/ourliving-ui';
import { TextArea } from '@ourliving/ourliving-ui';
const SubTitle = styled.div({
    display: 'flex',
    fontSize: style.fontSize.epsilon,
    fontWeight: style.fontWeight.bold,
    padding: `0px ${style.margin.m}px ${style.margin.m}px 0px`,
    alignItems: 'center',
});

const Buttons = styled.div({
    display: 'flex',
    alignSelf: 'flex-end',
    gap: '1rem',
});

const TextInput = styled(TextArea)({
    background: style.colors.inputBackground,
    border: `1px solid ${style.colors.inputBorder}`,
    width: '100%',
    height: '100%',
    maxHeight: '105%',
    borderRadius: style.roundCornerSize.small,
    outline: 'none',
    padding: style.margin.s,
    fontSize: style.fontSize.seta,
    resize: 'vertical',
});

export function AddonProjectSettingsGdpr({ forwardRef, isActive, setEditGdpr }) {
    const store = SettingStore;

    const onClick = () => {
        store.saveAccountAddonInfo();
        setEditGdpr(false);
    };

    const onCancel = () => {
        setEditGdpr(false);
    };

    const onChange = (evt: any) => {
        store.setValueTerms(evt.target.value, evt.target.name);
    };

    return (
        <Modal height={'800px'} width={'450px'} forwardRef={forwardRef} isActive={isActive}>
            <SubTitle>{L('settings')} </SubTitle>

            <FormField height={'90%'} title={L('edit_gdpr')} error={''}>
                <TextInput defaultValue={store.accountAddonInfo?.gdpr} name="gdpr" onChange={onChange} />
            </FormField>

            <Buttons>
                <Button
                    onClick={onClick}
                    style={{
                        marginTop: style.margin.m,
                        marginRight: '0px',
                    }}
                >
                    {L('save')}
                </Button>
                <Button
                    onClick={onCancel}
                    style={{
                        marginTop: style.margin.m,
                        marginRight: '0px',
                    }}
                >
                    {L('cancel')}
                </Button>
            </Buttons>
        </Modal>
    );
}
